import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=e728a61c&scoped=true&"
import script from "./DeliveryTime.vue?vue&type=script&async=true&lang=js&"
export * from "./DeliveryTime.vue?vue&type=script&async=true&lang=js&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeliveryTime.vue?vue&type=style&index=1&id=e728a61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e728a61c",
  null
  
)

export default component.exports